import {
  AdminInput,
  Button,
  Div,
  H5,
  Icon,
  Modal,
  PlusIcon,
  PropsModal,
  lightTheme,
  menuItemNameMaxLength,
  menuItemDescriptionMaxLength,
} from '@vgrubs/components';
import { CreateMenuCategoryV2Dto } from 'components/src/types/api/menu.types';
import {
  MenuAvailabilityV2Response,
  CategoryV2Response,
} from 'components/src/types/menu.types';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { AvailabilityComponent } from './AvailabilityComponent';

export const AddCategoryModal = ({
  addModal,
  closeModal,
  availability,
  setAvailability,
  setAddAvailabilityModal,
  handleAddCategory,
  handleEditCategory,
  edit,
  isPos,
}: PropsModal & {
  addModal: boolean | CategoryV2Response | null;
  availability: MenuAvailabilityV2Response[];
  setAvailability: Dispatch<SetStateAction<MenuAvailabilityV2Response[]>>;
  setAddAvailabilityModal: Dispatch<SetStateAction<boolean>>;
  handleAddCategory?: (
    name: CreateMenuCategoryV2Dto['name'],
    description: CreateMenuCategoryV2Dto['description'],
    scheduleIds: CreateMenuCategoryV2Dto['scheduleIds'],
    emptyForm: () => void
  ) => void;
  handleEditCategory?: (
    name: CreateMenuCategoryV2Dto['name'],
    description: CreateMenuCategoryV2Dto['description'],
    scheduleIds: CreateMenuCategoryV2Dto['scheduleIds'],
    emptyForm: () => void
  ) => void;
  edit?: boolean;
  isPos: boolean;
}) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const data = addModal;

  useEffect(() => {
    if (edit && typeof data === 'object') {
      setName(data?.name || '');
      setDescription(data?.description || '');
      setAvailability(data?.schedules || []);
    } else {
      emptyForm();
    }
  }, [data]);

  const emptyForm = () => {
    setName('');
    setDescription('');
    setAvailability([]);
  };

  const handleSubmit = () => {
    if (edit) {
      handleEditCategory?.(
        name,
        description,
        availability.map(({ id }) => id),
        emptyForm
      );
    } else {
      handleAddCategory?.(
        name,
        description,
        availability.map(({ id }) => id),
        emptyForm
      );
    }
  };

  return (
    <Modal
      isOpen={!!addModal}
      closeModal={closeModal}
      header={edit ? 'Edit Category' : 'Add Category'}
      logo={false}
      footer={
        <>
          <Button $selected $w="100%" onClick={handleSubmit}>
            Confirm
          </Button>
          <Button
            $mt="16"
            $selected
            $gray
            $w="100%"
            onClick={() => closeModal?.()}
          >
            Cancel
          </Button>
        </>
      }
      $numOfFloatingButtons={2}
    >
      <Div $flex $column $gap="24px">
        <AdminInput
          placeholder="Enter here"
          label="Category Name"
          value={name}
          onChange={({ target }: { target: HTMLInputElement }) =>
            setName(target.value)
          }
          maxLength={menuItemNameMaxLength}
          disabled={isPos}
          $textCenter
        />

        <AdminInput
          placeholder="Enter here"
          label="Description"
          type="textarea"
          value={description}
          onChange={({ target }: { target: HTMLInputElement }) =>
            setDescription(target.value)
          }
          maxLength={menuItemDescriptionMaxLength}
          disabled={isPos}
          $textCenter
        />

        {availability?.length > 0 ? (
          <>
            <Div $flex $alignCenter $between>
              <H5 $mb="0">Availability</H5>
              {!isPos && (
                <Icon $pointer onClick={() => setAddAvailabilityModal(true)}>
                  <PlusIcon />
                </Icon>
              )}
            </Div>

            <div>
              {availability.map((item, i) => (
                <AvailabilityComponent
                  item={item}
                  key={i}
                  availability={availability}
                  setAvailability={setAvailability}
                />
              ))}
            </div>
          </>
        ) : !isPos ? (
          <Div
            $flex
            $center
            $gap="8px"
            $pointer
            onClick={() => setAddAvailabilityModal(true)}
          >
            <Icon>
              <PlusIcon />
            </Icon>

            <H5 $m="0" $color={lightTheme.primary}>
              Add Availability
            </H5>
          </Div>
        ) : null}
      </Div>
    </Modal>
  );
};
